(() => {
  const initNavigation = () => {
    const header = document.querySelector('[data-lwn-header]');
    const drawer = document.querySelector('[data-lwn-drawer]');
    if (!header || !drawer || header.dataset.lwnReady === 'true') return;
    header.dataset.lwnReady = 'true';

    const drawerOpen = header.querySelector('[data-lwn-drawer-open]');
    const drawerClose = drawer.querySelector('[data-lwn-drawer-close]');
    const mobileRoot = drawer.querySelector('[data-lwn-root]');
    const mobileCategories = Array.from(drawer.querySelectorAll('[data-lwn-category]'));
    const categoryOpens = Array.from(drawer.querySelectorAll('[data-lwn-category-open]'));
    const overlay = document.querySelector('[data-lwn-overlay]');
    const desktopItems = Array.from(header.querySelectorAll('[data-lwn-item]'));
    let closeTimer;
    let previousFocus;
    let activeCategoryOpen;

    const showMobileRoot = (returnFocus = false) => {
      mobileCategories.forEach((category) => { category.hidden = true; });
      if (mobileRoot) mobileRoot.hidden = false;
      categoryOpens.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      if (returnFocus) activeCategoryOpen?.focus();
    };

    const closeMegas = (returnFocus = false) => {
      const focusedToggle = returnFocus ? document.activeElement?.closest('[data-lwn-mega]')?.closest('[data-lwn-item]')?.querySelector('[data-lwn-mega-toggle]') : null;
      document.body.classList.remove('lwn-mega-open');
      desktopItems.forEach((item) => {
        const toggle = item.querySelector('[data-lwn-mega-toggle]');
        const mega = item.querySelector('[data-lwn-mega]');
        item.classList.remove('is-open');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', toggle.getAttribute('aria-label')?.replace(/^Close /, 'Open '));
        }
        if (mega) mega.hidden = true;
      });
      if (focusedToggle instanceof HTMLElement) focusedToggle.focus();
    };

    const openMega = (item) => {
      const toggle = item.querySelector('[data-lwn-mega-toggle]');
      const mega = item.querySelector('[data-lwn-mega]');
      if (!toggle || !mega) return;
      clearTimeout(closeTimer);
      if (item.classList.contains('is-open')) return;
      closeMegas();
      item.classList.add('is-open');
      document.body.classList.add('lwn-mega-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', toggle.getAttribute('aria-label')?.replace(/^Open /, 'Close '));
      mega.hidden = false;
    };

    desktopItems.forEach((item) => {
      const toggle = item.querySelector('[data-lwn-mega-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', (event) => {
        if (item.classList.contains('is-open') && event.detail === 0) closeMegas();
        else openMega(item);
      });
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch') openMega(item);
      });
      item.addEventListener('pointerleave', () => {
        closeTimer = window.setTimeout(() => closeMegas(), 140);
      });
      item.addEventListener('focusin', (event) => {
        if (event.target !== toggle && !item.classList.contains('is-open')) openMega(item);
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) closeMegas();
      });
    });

    const closeDrawer = (restoreFocus = true) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawerOpen?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('lwn-drawer-open');
      showMobileRoot();
      if (mobileRoot) mobileRoot.scrollTop = 0;
      overlay?.classList.remove('is-visible');
      window.setTimeout(() => { if (overlay) overlay.hidden = true; }, 220);
      if (restoreFocus && previousFocus instanceof HTMLElement) previousFocus.focus();
    };

    const openDrawer = () => {
      closeMegas();
      showMobileRoot();
      if (mobileRoot) mobileRoot.scrollTop = 0;
      previousFocus = document.activeElement;
      if (overlay) {
        overlay.hidden = false;
        requestAnimationFrame(() => overlay.classList.add('is-visible'));
      }
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawerOpen?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('lwn-drawer-open');
      drawerClose?.focus();
    };

    drawerOpen?.addEventListener('click', openDrawer);
    drawerClose?.addEventListener('click', () => closeDrawer());
    overlay?.addEventListener('click', () => closeDrawer());
    drawer.querySelector('[data-lwn-search]')?.addEventListener('click', () => closeDrawer(false));

    categoryOpens.forEach((button) => button.addEventListener('click', () => {
      const category = document.getElementById(button.getAttribute('aria-controls'));
      if (!mobileRoot || !category) return;
      activeCategoryOpen = button;
      mobileRoot.hidden = true;
      mobileCategories.forEach((page) => { page.hidden = page !== category; });
      category.scrollTop = 0;
      button.setAttribute('aria-expanded', 'true');
      category.querySelector('[data-lwn-category-back]')?.focus();
    }));
    mobileCategories.forEach((category) => {
      category.querySelector('[data-lwn-category-back]')?.addEventListener('click', () => showMobileRoot(true));
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeMegas();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (drawer.classList.contains('is-open')) {
          if (mobileCategories.some((category) => !category.hidden)) showMobileRoot(true);
          else closeDrawer();
        }
        else closeMegas(true);
      }
      if (event.key === 'Tab' && drawer.classList.contains('is-open')) {
        const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled])')).filter((el) => !el.closest('[hidden]') && el.getClientRects().length > 0);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    });

    header.querySelectorAll('[data-lwn-cart]').forEach((cartLink) => {
      cartLink.addEventListener('click', (event) => {
        const cartDrawer = document.getElementById('mini-cart');
        if (cartDrawer) {
          event.preventDefault();
          closeDrawer(false);
          cartDrawer.open = true;
        }
      });
    });

    const updateCartCount = (event) => {
      const count = event?.detail?.cart?.item_count;
      if (typeof count !== 'number') return;
      header.querySelectorAll('[data-lwn-cart]').forEach((cartLink) => {
        cartLink.setAttribute('aria-label', `Cart, ${count} ${count === 1 ? 'item' : 'items'}`);
        const badge = cartLink.querySelector('.lwn-cart-count, .lwn-action-count');
        if (badge) {
          badge.textContent = count;
          badge.hidden = count === 0;
        }
      });
    };
    document.documentElement.addEventListener('cart:updated', updateCartCount);
    document.documentElement.addEventListener('cart:refresh', updateCartCount);

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1180 && drawer.classList.contains('is-open')) closeDrawer();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNavigation, { once: true });
  else initNavigation();
  document.addEventListener('shopify:section:load', initNavigation);
})();
